import React from "react";

export default function IconTimer() {
  return (
    <svg
      className="w-3 h-3.5"
      preserveAspectRatio="none"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12.2619C4.76232 12.2619 3.57534 11.8054 2.70017 10.9927C1.825 10.18 1.33333 9.07784 1.33333 7.92857C1.33333 6.7793 1.825 5.6771 2.70017 4.86444C3.57534 4.05178 4.76232 3.59524 6 3.59524C7.23768 3.59524 8.42466 4.05178 9.29983 4.86444C10.175 5.6771 10.6667 6.7793 10.6667 7.92857C10.6667 9.07784 10.175 10.18 9.29983 10.9927C8.42466 11.8054 7.23768 12.2619 6 12.2619ZM10.6867 4.45571L11.6333 3.57667C11.3333 3.26095 11.0333 2.97619 10.6933 2.70381L9.74667 3.59524C8.71333 2.81524 7.41333 2.35714 6 2.35714C4.4087 2.35714 2.88258 2.94413 1.75736 3.98898C0.632141 5.03382 0 6.45094 0 7.92857C0 9.40621 0.632141 10.8233 1.75736 11.8682C2.88258 12.913 4.4087 13.5 6 13.5C9.33333 13.5 12 11.0052 12 7.92857C12 6.61619 11.5067 5.40905 10.6867 4.45571ZM5.33333 8.54762H6.66667V4.83333H5.33333V8.54762ZM8 0.5H4V1.7381H8V0.5Z"
        fill="#403434"
      ></path>
    </svg>
  );
}
